/* eslint-disable @typescript-eslint/no-explicit-any */
/**
 * @desc 手机端版本检查
 */
import { defaultSuccess, defaultError, http } from "@/plugins/axios";

export default async function (
  versionNum: string,

  success: ({
    data,
    ext,
    state,
    errors,
  }: {
    data: member.AppVersionDTO;
    ext: ObjectMap;
    state: "SUCCESS" | "FAIL" | "EXCEPTION";
    errors?: Array<string>;
  }) => void = defaultSuccess,
  fail: (error: string) => void = defaultError
): Promise<void> {
  return http({
    method: "get",
    url: `/member/setting/app/version/checking/${versionNum}`,
  })
    .then((data) => success(data as any))
    .catch((error) => fail(error));
}
